import React, { Dispatch, SetStateAction } from 'react';
import { Input } from 'components';

interface Props {
  email: string;
  password: string;
  setEmail: Dispatch<SetStateAction<string>>;
  setPassword: Dispatch<SetStateAction<string>>;
  onEnterKeyPress: () => void;
}

const LoginForm = ({
  email,
  password,
  setEmail,
  setPassword,
  onEnterKeyPress
}: Props) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onEnterKeyPress(); // 엔터 키를 눌렀을 때 호출
    }
  };
  return (
    <form className="mb-6 flex w-full flex-col gap-6">
      <Input inputClassName="bg-white h-10" label="Email" type="text" value={email} setValue={setEmail} />
      <Input
        inputClassName="bg-white h-10"
        label="Password"
        type="password"
        value={password}
        setValue={setPassword}
        onKeyDown={handleKeyDown} // 입력 필드에서 엔터 키 감지
      />
    </form>
  );
};

export default LoginForm;
